import React from "react";

const SvgParagraphLeftAlign = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M22.5 23.271h-21a1.25 1.25 0 010-2.5h21a1.25 1.25 0 010 2.5zM19.637 3.225H1.5a1.25 1.25 0 010-2.5h18.137a1.25 1.25 0 010 2.5zM15.818 9.907H1.5a1.25 1.25 0 010-2.5h14.318a1.25 1.25 0 110 2.5zM18.682 16.589H1.5a1.25 1.25 0 110-2.5h17.182a1.25 1.25 0 010 2.5z" />
  </svg>
);

export default SvgParagraphLeftAlign;
